/**
 * Thin React bridge: reads turnIndicatorVM + ThemeContext, builds turn-indicator model.
 */
import { useSignals } from '@preact/signals-react/runtime'
import {
  buildTurnIndicatorModel,
  type TurnIndicatorModel,
} from '../../../../deps/ui/turnIndicator'
import { useWebContainer } from '../../../providers/DepProvider/DepProvider'
import { useTheme } from '../../../../contexts/ThemeContext'

export type { TurnIndicatorModel }

/** Returns null when there is no active-turn message to show. */
export function useTurnIndicatorModel(): TurnIndicatorModel | null {
  useSignals()

  const container = useWebContainer()
  const vm = container.turnIndicatorVM
  const mateListVM = container.mateListVM
  const { getPlayerColor, getAppColor, resolvedTheme, playerPiece } = useTheme()

  return buildTurnIndicatorModel({
    hasActiveGame: mateListVM.hasActiveGame.value,
    turnMessageText: vm.turnMessageText.value,
    turnMessageDataAttrs: vm.turnMessageDataAttrs.value,
    activePlayerId: vm.turnIndicatorPlayerId.value,
    playerIds: mateListVM.players.value.map((player) => player.id),
    getPlayerColor,
    neutral: resolvedTheme.neutral,
    app: getAppColor(),
    playerPiece,
  })
}
